module.exports = __webpack_public_path__ + "img/Tags.9da32938.svg";